<template>
  <div>
    {{ getText() }}
  </div>
</template>

<script>
export default {
  name: 'PrinterType',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    getText() {
      let text = '-';

      switch (this.type) {
        case 'CANON':
          text = 'Canon';
          break;

        case 'BROTHER':
          text = 'Brother';
          break;

        case 'EPSON':
          text = 'Epson';
          break;

        case 'GENERIC':
          text = 'Obecná';
          break;

        default:
          text = '-';
      }

      return text;
    },
  },
};
</script>
